module.exports = __webpack_public_path__ + "media/images/icons/material/tray-arrow-down-3e7637d92a1dff3356114a1d3e847dac.svg";